module.exports = __webpack_public_path__ + "static/img_0397-6c95b5dab80c23c288cae1d9088be833.webp";